// Trailing rolling-average smoother for the telemetry chart. Each output[i]
// is the mean of all non-null values in samples[i-windowS+1 .. i]. Indices
// where every value in the window is null/missing return null so the chart
// can draw a real gap rather than stretching the previous value.
//
// Pure function — no side effects. windowS === 1 (or 0) returns a copy of
// the raw series.

export function rollingAverage(samples, key, windowS) {
  const out = new Array(samples.length);
  if (windowS <= 1) {
    for (let i = 0; i < samples.length; i += 1) {
      const v = samples[i]?.[key];
      out[i] = v == null ? null : v;
    }
    return out;
  }

  let sum = 0;
  let count = 0;
  const queue = new Array(windowS).fill(null);
  let qHead = 0;

  for (let i = 0; i < samples.length; i += 1) {
    // Drop the oldest value leaving the window.
    const out_old = queue[qHead];
    if (out_old != null) {
      sum -= out_old;
      count -= 1;
    }
    // Add the new value.
    const v = samples[i]?.[key];
    queue[qHead] = v == null ? null : v;
    if (v != null) {
      sum += v;
      count += 1;
    }
    qHead = (qHead + 1) % windowS;

    out[i] = count > 0 ? sum / count : null;
  }

  return out;
}
